export const statuses = {	
		'CREATED': { color: '#887FFF' },
		'GEOCODED': { color: '#887FFF' },
		'ERRORED': { color: '#D0021B' },
		'GEOCODE_FAILED': { color: '#D0021B' },
		'GEOCODE_FAILED_PICKUP': { color: '#D0021B' },
		'GEOCODE_FAILED_DROPOFF': { color: '#D0021B' },
		'ASSIGNED': { color: '#887FFF' },
		'CANCELLED': { color: '#D0021B' },
		'CANCELLED_BEFORE_PICKUP': { color: '#D0021B' },
		'CANCELLED_AFTER_PICKUP': { color: '#D0021B' },
		'DELAYED': { color: '#F5A623' },
		'DROPOFF_DELAY': { color: '#F5A623' },
		'PICKUP_DELAY': { color: '#F5A623' },
		'RETURNING': { color: '#F5A623' },
		'RETURN_EN_ROUTE': { color: '#F5A623' },
		'RETURN_DELAY': { color: '#F5A623' },
		'RETURN_READY': { color: '#F5A623' },
		'RETURNED': { color: '#CFCFCF' },
		'RETURN_SUCCEEDED': { color: '#CFCFCF' },
		'FAILED': { color: '#D0021B' },
		'PICKUP_FAILED': { color: '#D0021B' },
		'DROPOFF_FAILED': { color: '#D0021B' },
		'RETURN_FAILED': { color: '#D0021B' },
		'ON TIME': { color: '#76C520' },
		'PICKUP_EN_ROUTE': { color: '#76C520' },
		'PICKUP_READY': { color: '#76C520' },
		'PICKUP_SUCCEEDED': { color: '#76C520' },
		'DROPOFF_EN_ROUTE': { color: '#76C520' },
		'DROPOFF_READY': { color: '#76C520' },
		'COMPLETED': { color: '#CFCFCF' },
		'DROPOFF_SUCCEEDED': { color: '#CFCFCF' }
};